<template>
  <div>
    <div>
      <el-button type="primary" :style="buttonStyle" >
        <a :href="demoExcel" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank">Download CAC Intergrated Marketing Solutions</a>
      </el-button>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  data: () => ({
     saveBtnStatue:false,  //保存铵钮状态
      demoExcel:'./CAC2025 Integrated Marketing Solutions.pdf'
  }),

  components: {},
  mounted() {

  },
  methods: {
    downfile(){

    },


  }
}
</script>
<style lang="less">


</style>

